/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import '@/store/mutation_types';
import SearchInput from './components/SearchInput';
import SortItem from './components/SortItem';
import XImg from '@/components/XImg';
import ImgItem from '@/components/ImgItem';
import CircleImg from '@/components/CircleImg';
import BottomLine from '@/components/BottomLine';
import bannerImg from '@/resources/images/mall/b.jpg';
import default_wanjia from '@/resources/images/mall/default_wanjia.jpg';
import { CartSelect, getMainPage, MallPV } from '@/api/mall';
export default {
  data: function data() {
    return {
      bannerImg: bannerImg,
      defaultImg: default_wanjia,
      next: true,
      testImg: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1626039801,2689375718&fm=27&gp=0.jpg',
      saleList: [],
      categoryList: [],
      banners: [],
      shopsList: []
    };
  },
  created: function created() {
    var _this = this;

    getMainPage().then(function (data) {
      _this.banners = data.banners[0];
      _this.saleList = data.saleList;
      _this.categoryList = data.categoryList;
      _this.shopsList = data.shopsList;
    });
    MallPV();
  },
  components: {
    SearchInput: SearchInput,
    XImg: XImg,
    ImgItem: ImgItem,
    CircleImg: CircleImg,
    BottomLine: BottomLine,
    SortItem: SortItem
  },
  computed: _objectSpread(_objectSpread({}, mapState({})), {}, {
    bannerImgComp: function bannerImgComp() {
      if (!this.banners || this.banners.imageServerPath == '' || this.banners.imageRelativePath == '') {
        return this.bannerImg;
      } else {
        return this.banners.imageServerPath + this.banners.imageRelativePath;
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations({})), {}, {
    search: function search(keywords) {
      if (Utils.trim(keywords).length > 0) {
        this.$router.push({
          name: 'MallGoodsList',
          query: {
            keywords: keywords
          }
        });
      } else {
        keywords = '';
      }

      this.keywords = keywords;
    },
    goCategory: function goCategory(id, name) {
      this.$router.push({
        name: 'MallGoodsList',
        query: {
          goodsCategoryId: id,
          goodsCategoryName: name
        }
      });
    }
  })
};